import { Input } from 'antd';
const UiTextBox = ({
  label,
  onChange,
  required = false,
  disabled = false,
  name,
  style,
  ...restProps
}) => {
  return <div>
    <div style={{ padding: "10px" }}>
      {label && (
        <label>
          {label} {required && <span style={{ color: 'red' }}>*</span>}
        </label>
      )}
    </div>
    <div style={{ padding: "0px 10px" }}>
      <Input
        onChange={onChange}
        name={name}
        required={required}
        disabled={disabled}
        style={style}
        {...restProps}
      />
    </div>
  </div>
};
export default UiTextBox